import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfig } from '@nha/api/shared';

@Injectable({
	providedIn: 'root'
})
export class ReportingApiConfiguration extends ApiConfig {
	constructor() {
		const httpClient = inject(HttpClient);

		super(httpClient, 'reporting');
	}
}
